module.exports = __webpack_public_path__ + "img/alert-yellow.17abb664.svg";